import { guardedClient as clientRequest } from '@repo/shared/helpers';
import { Task } from '@repo/shared/domain';

export interface GetTaskParams {
	taskId: string;
	query?: string;
	headers?: Record<string, string>;
}

export const getTask = async ({ taskId, query, headers }: GetTaskParams): Promise<Task> => {
	console.log('getTask called:', { taskId, query });
	const { body } = await clientRequest.get<undefined, Task>(`/api/tasks/${taskId}${query ? `?${query}` : ''}`, {
		schema: undefined, // Removed schema validation for debugging
		...(headers && { headers }),
	});
	console.log('getTask response:', body);
	return body;
};

export const updateTask = async (
	taskId: string,
	task: Partial<Task>,
	query?: string,
	headers?: Record<string, string>,
): Promise<void> => {
	await clientRequest.put(`/api/tasks/${taskId}${query ? `?${query}` : ''}`, task, {
		...(headers && { headers }),
	});
};

export const saveTaskDraft = async (
	taskId: string,
	task: Partial<Task>,
	query?: string,
	headers?: Record<string, string>,
): Promise<void> => {
	await clientRequest.put(`/api/tasks/${taskId}/draft${query ? `?${query}` : ''}`, task, {
		...(headers && { headers }),
	});
};
